<template>
  <div class="access-page">
    <!-- 顶部统计卡片 -->
    <div class="stat-row">
      <div v-for="(item, index) in statCards" :key="index" class="stat-card">
        <div class="stat-left">
          <div class="stat-value" :style="{ color: item.color }">{{ item.value }}</div>
          <div class="stat-label">{{ item.label }}</div>
        </div>
        <div class="stat-icon" :style="{ background: item.bgColor, color: item.color }">{{ item.icon }}</div>
      </div>
    </div>

    <!-- 第一行：准入流程 + 审核状态分布 -->
    <div class="chart-row">
      <div class="chart-box chart-flow">
        <div class="chart-header">
          <span class="chart-title">◈ 供应商准入流程</span>
        </div>
        <div class="flow-steps">
          <div v-for="(step, idx) in flowSteps" :key="idx" class="flow-step" :class="{ active: step.active, done: step.done }">
            <div class="step-circle">
              <span v-if="step.done">✓</span>
              <span v-else>{{ idx + 1 }}</span>
            </div>
            <div class="step-name">{{ step.name }}</div>
            <div class="step-desc">{{ step.desc }}</div>
            <div v-if="idx < flowSteps.length - 1" class="step-arrow">→</div>
          </div>
        </div>
      </div>
      <div class="chart-box chart-small">
        <div class="chart-header">
          <span class="chart-title">◉ 审核状态分布</span>
        </div>
        <div ref="chartAuditStatus" class="chart-body"></div>
      </div>
    </div>

    <!-- 第二行：月度准入趋势 + 风险评级 -->
    <div class="chart-row">
      <div class="chart-box chart-medium">
        <div class="chart-header">
          <span class="chart-title">▣ 月度供应商准入趋势</span>
        </div>
        <div ref="chartMonthTrend" class="chart-body"></div>
      </div>
      <div class="chart-box chart-medium">
        <div class="chart-header">
          <span class="chart-title">◆ 供应商风险评级分布</span>
        </div>
        <div ref="chartRisk" class="chart-body"></div>
      </div>
    </div>

    <!-- 底部：待审核供应商列表 -->
    <div class="chart-box table-box">
      <div class="chart-header">
        <span class="chart-title">◊ 待审核供应商列表</span>
        <div class="table-actions">
          <button class="action-btn" @click="handleBatchPass">批量通过</button>
          <button class="action-btn reject" @click="handleBatchReject">批量驳回</button>
        </div>
      </div>
      <div class="table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th><input type="checkbox" v-model="selectAll" @change="toggleSelectAll"></th>
              <th>供应商名称</th>
              <th>申请时间</th>
              <th>供应品类</th>
              <th>注册资本</th>
              <th>资质文件</th>
              <th>审核状态</th>
              <th>风险评级</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in supplierList" :key="idx">
              <td><input type="checkbox" v-model="item.selected"></td>
              <td class="name-cell">
                <div class="supplier-name">{{ item.name }}</div>
                <div class="supplier-code">{{ item.code }}</div>
              </td>
              <td>{{ item.applyTime }}</td>
              <td><span class="tag-category">{{ item.category }}</span></td>
              <td>{{ item.capital }}</td>
              <td>
                <span class="doc-badge" :class="{ complete: item.docs === 5 }">
                  {{ item.docs }}/5
                </span>
              </td>
              <td>
                <span class="status-badge" :class="item.status">{{ statusText(item.status) }}</span>
              </td>
              <td>
                <span class="risk-badge" :class="item.risk">{{ riskText(item.risk) }}</span>
              </td>
              <td>
                <button class="op-btn pass" @click="handlePass(item)">通过</button>
                <button class="op-btn reject" @click="handleReject(item)">驳回</button>
                <button class="op-btn detail" @click="handleDetail(item)">详情</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer">
        <span class="footer-info">共 {{ supplierList.length }} 条记录</span>
        <div class="pagination">
          <button class="page-btn" :disabled="currentPage === 1" @click="currentPage--">←</button>
          <span class="page-num" v-for="p in pageList" :key="p" :class="{ active: p === currentPage }" @click="currentPage = p">{{ p }}</span>
          <button class="page-btn" :disabled="currentPage === totalPage" @click="currentPage++">→</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SrmSupplierAccess',
  data() {
    return {
      statCards: [
        { label: '本月新增申请', value: '46', icon: '◉', color: '#00d4ff', bgColor: 'rgba(0, 212, 255, 0.1)' },
        { label: '待审核', value: '12', icon: '◈', color: '#f0a030', bgColor: 'rgba(240, 160, 48, 0.1)' },
        { label: '已通过', value: '28', icon: '✓', color: '#00e5a0', bgColor: 'rgba(0, 229, 160, 0.1)' },
        { label: '已驳回', value: '6', icon: '✕', color: '#ff6b6b', bgColor: 'rgba(255, 107, 107, 0.1)' },
        { label: '黑名单', value: '3', icon: '⚠', color: '#ff6b9d', bgColor: 'rgba(255, 107, 157, 0.1)' },
        { label: '累计注册', value: '1,248', icon: '◊', color: '#a855f7', bgColor: 'rgba(168, 85, 247, 0.1)' }
      ],
      flowSteps: [
        { name: '在线注册', desc: '填写基本信息', done: true, active: false },
        { name: '资质提交', desc: '上传证照文件', done: true, active: false },
        { name: '初审评估', desc: '资料完整性审核', done: true, active: false },
        { name: '现场考察', desc: '实地考察验证', done: false, active: true },
        { name: '终审决策', desc: '综合评定准入', done: false, active: false },
        { name: '签约入驻', desc: '签署合作协议', done: false, active: false }
      ],
      supplierList: [
        { name: '深圳星河精密科技有限公司', code: 'SUP-2026-0046', applyTime: '2026-06-25 09:30', category: '机械加工', capital: '5,000万', docs: 5, status: 'auditing', risk: 'low', selected: false },
        { name: '苏州恒远新材料股份有限公司', code: 'SUP-2026-0045', applyTime: '2026-06-25 08:15', category: '化工材料', capital: '1.2亿', docs: 4, status: 'auditing', risk: 'low', selected: false },
        { name: '东莞锐捷金属制品有限公司', code: 'SUP-2026-0044', applyTime: '2026-06-24 16:45', category: '金属加工', capital: '3,000万', docs: 5, status: 'pending', risk: 'medium', selected: false },
        { name: '杭州云智半导体设备有限公司', code: 'SUP-2026-0043', applyTime: '2026-06-24 14:20', category: '电子元器件', capital: '8,000万', docs: 3, status: 'auditing', risk: 'low', selected: false },
        { name: '武汉光谷光电技术研究院', code: 'SUP-2026-0042', applyTime: '2026-06-24 11:00', category: '光电技术', capital: '2,000万', docs: 5, status: 'pending', risk: 'high', selected: false },
        { name: '青岛海润化工集团有限公司', code: 'SUP-2026-0041', applyTime: '2026-06-23 17:30', category: '化工材料', capital: '2.5亿', docs: 5, status: 'auditing', risk: 'low', selected: false },
        { name: '成都西部智能装备有限公司', code: 'SUP-2026-0040', applyTime: '2026-06-23 15:10', category: '智能装备', capital: '6,000万', docs: 4, status: 'pending', risk: 'medium', selected: false },
        { name: '南京博睿电子科技有限公司', code: 'SUP-2026-0039', applyTime: '2026-06-23 10:45', category: '电子元器件', capital: '1,500万', docs: 2, status: 'auditing', risk: 'high', selected: false }
      ],
      selectAll: false,
      currentPage: 1,
      totalPage: 3,
      charts: {}
    }
  },
  computed: {
    pageList() {
      return [1, 2, 3]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initAuditStatusChart()
      this.initMonthTrendChart()
      this.initRiskChart()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    Object.values(this.charts).forEach(chart => chart && chart.dispose())
  },
  methods: {
    handleResize() {
      Object.values(this.charts).forEach(chart => chart && chart.resize())
    },
    statusText(status) {
      const map = { pending: '待初审', auditing: '审核中', passed: '已通过', rejected: '已驳回' }
      return map[status] || status
    },
    riskText(risk) {
      const map = { low: '低风险', medium: '中风险', high: '高风险' }
      return map[risk] || risk
    },
    toggleSelectAll() {
      this.supplierList.forEach(item => item.selected = this.selectAll)
    },
    handlePass(item) {
      alert(`已通过：${item.name}`)
      item.status = 'passed'
    },
    handleReject(item) {
      alert(`已驳回：${item.name}`)
      item.status = 'rejected'
    },
    handleDetail(item) {
      alert(`查看详情：${item.name}\n\n注册资本：${item.capital}\n资质文件：${item.docs}/5 项\n风险评级：${this.riskText(item.risk)}`)
    },
    handleBatchPass() {
      const selected = this.supplierList.filter(i => i.selected)
      if (!selected.length) { alert('请先选择供应商'); return }
      alert(`批量通过 ${selected.length} 家供应商`)
      selected.forEach(i => i.status = 'passed')
    },
    handleBatchReject() {
      const selected = this.supplierList.filter(i => i.selected)
      if (!selected.length) { alert('请先选择供应商'); return }
      alert(`批量驳回 ${selected.length} 家供应商`)
      selected.forEach(i => i.status = 'rejected')
    },

    // 审核状态分布（饼图）
    initAuditStatusChart() {
      const chart = this.$echarts.init(this.$refs.chartAuditStatus)
      this.charts.auditStatus = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' },
          formatter: '{b}: {c}家 ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: { color: '#8c9bb3', fontSize: 11 },
          itemWidth: 10,
          itemHeight: 10
        },
        series: [{
          type: 'pie',
          radius: ['40%', '65%'],
          center: ['35%', '50%'],
          avoidLabelOverlap: false,
          label: { show: false },
          labelLine: { show: false },
          data: [
            { value: 12, name: '待初审', itemStyle: { color: '#f0a030' } },
            { value: 18, name: '审核中', itemStyle: { color: '#00d4ff' } },
            { value: 28, name: '已通过', itemStyle: { color: '#00e5a0' } },
            { value: 6, name: '已驳回', itemStyle: { color: '#ff6b6b' } },
            { value: 3, name: '黑名单', itemStyle: { color: '#ff6b9d' } }
          ]
        }]
      })
    },

    // 月度准入趋势（柱状图 + 折线）
    initMonthTrendChart() {
      const chart = this.$echarts.init(this.$refs.chartMonthTrend)
      this.charts.monthTrend = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' }
        },
        legend: {
          data: ['新增申请', '审核通过'],
          textStyle: { color: '#8c9bb3' },
          right: 10,
          top: 0
        },
        grid: { left: 45, right: 20, top: 40, bottom: 25 },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月'],
          axisLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.2)' } },
          axisLabel: { color: '#8c9bb3', fontSize: 11 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 11 },
          splitLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.1)' } }
        },
        series: [
          {
            name: '新增申请',
            type: 'bar',
            barWidth: 16,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00d4ff' },
                { offset: 1, color: 'rgba(0, 212, 255, 0.2)' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            data: [32, 28, 35, 42, 38, 46]
          },
          {
            name: '审核通过',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#00e5a0', width: 2 },
            itemStyle: { color: '#00e5a0' },
            data: [24, 22, 28, 34, 30, 28]
          }
        ]
      })
    },

    // 风险评级分布（横向条形图）
    initRiskChart() {
      const chart = this.$echarts.init(this.$refs.chartRisk)
      this.charts.risk = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' },
          axisPointer: { type: 'shadow' }
        },
        grid: { left: 60, right: 40, top: 10, bottom: 10 },
        xAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 10 },
          splitLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.1)' } }
        },
        yAxis: {
          type: 'category',
          data: ['高风险', '中风险', '低风险'],
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 12 }
        },
        series: [{
          type: 'bar',
          barWidth: 20,
          data: [
            { value: 45, itemStyle: { color: '#ff6b6b', borderRadius: [0, 4, 4, 0] } },
            { value: 128, itemStyle: { color: '#f0a030', borderRadius: [0, 4, 4, 0] } },
            { value: 356, itemStyle: { color: '#00e5a0', borderRadius: [0, 4, 4, 0] } }
          ],
          label: {
            show: true,
            position: 'right',
            color: '#fff',
            fontSize: 12,
            formatter: '{c}家'
          }
        }]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.access-page {
  width: 100%;
  min-height: 100%;
  padding-bottom: 20px;
}

/* ==================== 统计卡片 ==================== */
.stat-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.stat-card {
  background: rgba(0, 212, 255, 0.04);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s;

  &:hover {
    background: rgba(0, 212, 255, 0.07);
    border-color: rgba(0, 212, 255, 0.2);
    transform: translateY(-2px);
  }
}

.stat-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
}

.stat-label {
  font-size: 12px;
  color: #8c9bb3;
}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

/* ==================== 图表行 ==================== */
.chart-row {
  display: grid;
  gap: 16px;
  margin-bottom: 16px;

  &:nth-of-type(2) {
    grid-template-columns: 1.8fr 1fr;
  }

  &:nth-of-type(3) {
    grid-template-columns: 1fr 1fr;
  }
}

.chart-box {
  background: rgba(0, 212, 255, 0.03);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.chart-title {
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
}

.chart-body {
  flex: 1;
  min-height: 240px;
}

/* ==================== 准入流程 ==================== */
.flow-steps {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 10px;
  flex: 1;
}

.flow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;

  .step-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 2px solid rgba(140, 155, 179, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #8c9bb3;
    background: rgba(1, 16, 57, 0.8);
    transition: all 0.3s;
    z-index: 2;
  }

  .step-name {
    font-size: 13px;
    color: #8c9bb3;
    margin-top: 10px;
    font-weight: bold;
    text-align: center;
  }

  .step-desc {
    font-size: 11px;
    color: rgba(140, 155, 179, 0.6);
    margin-top: 4px;
    text-align: center;
  }

  .step-arrow {
    position: absolute;
    right: -20px;
    top: 12px;
    color: rgba(140, 155, 179, 0.3);
    font-size: 16px;
    z-index: 1;
  }

  &.done {
    .step-circle {
      border-color: #00e5a0;
      color: #00e5a0;
      background: rgba(0, 229, 160, 0.1);
    }
    .step-name { color: #00e5a0; }
  }

  &.active {
    .step-circle {
      border-color: #00d4ff;
      color: #00d4ff;
      background: rgba(0, 212, 255, 0.15);
      box-shadow: 0 0 15px rgba(0, 212, 255, 0.3);
      animation: stepPulse 2s infinite;
    }
    .step-name { color: #00d4ff; }
  }
}

@keyframes stepPulse {
  0%, 100% { box-shadow: 0 0 10px rgba(0, 212, 255, 0.2); }
  50% { box-shadow: 0 0 20px rgba(0, 212, 255, 0.5); }
}

/* ==================== 表格区域 ==================== */
.table-box {
  min-height: 400px;
}

.table-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid rgba(0, 212, 255, 0.4);
  background: rgba(0, 212, 255, 0.08);
  color: #00d4ff;
  transition: all 0.3s;

  &:hover {
    background: rgba(0, 212, 255, 0.15);
    box-shadow: 0 0 10px rgba(0, 212, 255, 0.2);
  }

  &.reject {
    border-color: rgba(255, 107, 107, 0.4);
    background: rgba(255, 107, 107, 0.08);
    color: #ff6b6b;

    &:hover {
      background: rgba(255, 107, 107, 0.15);
      box-shadow: 0 0 10px rgba(255, 107, 107, 0.2);
    }
  }
}

.table-wrap {
  flex: 1;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 212, 255, 0.05);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 212, 255, 0.2);
    border-radius: 2px;
  }
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th, td {
    padding: 12px 14px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 212, 255, 0.08);
    white-space: nowrap;
  }

  th {
    background: rgba(0, 212, 255, 0.06);
    color: #8c9bb3;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 1px;
  }

  tbody tr {
    transition: all 0.2s;

    &:hover {
      background: rgba(0, 212, 255, 0.04);
    }
  }
}

.name-cell {
  .supplier-name {
    color: #fff;
    font-size: 13px;
  }

  .supplier-code {
    color: #8c9bb3;
    font-size: 11px;
    margin-top: 2px;
  }
}

.tag-category {
  padding: 2px 10px;
  border-radius: 4px;
  background: rgba(0, 212, 255, 0.1);
  color: #00d4ff;
  font-size: 12px;
}

.doc-badge {
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(240, 160, 48, 0.1);
  color: #f0a030;
  font-size: 12px;

  &.complete {
    background: rgba(0, 229, 160, 0.1);
    color: #00e5a0;
  }
}

.status-badge {
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;

  &.pending {
    background: rgba(240, 160, 48, 0.1);
    color: #f0a030;
  }

  &.auditing {
    background: rgba(0, 212, 255, 0.1);
    color: #00d4ff;
  }

  &.passed {
    background: rgba(0, 229, 160, 0.1);
    color: #00e5a0;
  }

  &.rejected {
    background: rgba(255, 107, 107, 0.1);
    color: #ff6b6b;
  }
}

.risk-badge {
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;

  &.low {
    background: rgba(0, 229, 160, 0.1);
    color: #00e5a0;
  }

  &.medium {
    background: rgba(240, 160, 48, 0.1);
    color: #f0a030;
  }

  &.high {
    background: rgba(255, 107, 107, 0.1);
    color: #ff6b6b;
  }
}

.op-btn {
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  border: none;
  margin-right: 6px;
  transition: all 0.2s;

  &.pass {
    background: rgba(0, 229, 160, 0.15);
    color: #00e5a0;

    &:hover {
      background: rgba(0, 229, 160, 0.3);
    }
  }

  &.reject {
    background: rgba(255, 107, 107, 0.15);
    color: #ff6b6b;

    &:hover {
      background: rgba(255, 107, 107, 0.3);
    }
  }

  &.detail {
    background: rgba(0, 212, 255, 0.1);
    color: #8c9bb3;

    &:hover {
      background: rgba(0, 212, 255, 0.2);
      color: #00d4ff;
    }
  }
}

/* ==================== 分页 ==================== */
.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 212, 255, 0.08);
  margin-top: 8px;
}

.footer-info {
  font-size: 12px;
  color: #8c9bb3;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 6px;
}

.page-btn {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid rgba(0, 212, 255, 0.2);
  background: transparent;
  color: #8c9bb3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    border-color: #00d4ff;
    color: #00d4ff;
    background: rgba(0, 212, 255, 0.08);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.page-num {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #8c9bb3;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s;

  &:hover {
    border-color: rgba(0, 212, 255, 0.3);
    color: #00d4ff;
  }

  &.active {
    background: rgba(0, 212, 255, 0.15);
    border-color: #00d4ff;
    color: #00d4ff;
  }
}

/* ==================== 响应式 ==================== */
@media (max-width: 1400px) {
  .stat-row {
    grid-template-columns: repeat(3, 1fr);
  }

  .chart-row:nth-of-type(2),
  .chart-row:nth-of-type(3) {
    grid-template-columns: 1fr;
  }

  .flow-steps {
    flex-wrap: wrap;
    gap: 16px;

    .flow-step {
      min-width: 100px;

      .step-arrow {
        display: none;
      }
    }
  }
}

@media (max-width: 768px) {
  .stat-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .chart-body {
    min-height: 200px;
  }

  .op-btn {
    padding: 2px 6px;
    font-size: 10px;
    margin-right: 3px;
  }
}
</style>